module.exports = __webpack_public_path__ + "img/ebere.e8e1454c.png";